import { _ as r } from "../internals/export.js";
import { i as t } from "../internals/iterate.js";
import { c as e } from "../internals/create-property.js";
r({
  target: "Object",
  stat: !0
}, {
  fromEntries: function fromEntries(r) {
    var n = {};
    return t(r, function (r, t) {
      e(n, r, t);
    }, {
      AS_ENTRIES: !0
    }), n;
  }
});